import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { Pagination } from '@core/entities';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BannerService {
  private readonly _http = inject(HttpClient);

  private readonly _apiUrl = environment.apiUrl;

  find(pagination: Pagination) {
    return this._http.get(`${this._apiUrl}/allBanners/${pagination.page}/${pagination.pageSize}`).pipe(
      map((res: any) => {
        return res.result;
      }),
    );
  }

  get(id: number) {
    return this._http.get(`${this._apiUrl}/getBannerbyId/${id}`).pipe(
      map((res: any) => {
        return res.result;
      }),
    );
  }

  create(formData: FormData) {
    return this._http.post(`${this._apiUrl}/createBanner`, formData);
  }

  update(id: number, formData: FormData) {
    return this._http.put(`${this._apiUrl}/updateBanner/${id}`, formData);
  }

  delete(id: number) {
    return this._http.delete(`${this._apiUrl}/deleteBanner/${id}`);
  }

  bannerWebStatistics() {
    return this._http.get(`${this._apiUrl}/getBannerStatisticForDesktop`).pipe(
      map((res: any) => {
        return res.result;
      }),
    );
  }

  bannerMobileStatistics() {
    return this._http.get(`${this._apiUrl}/getBannerStatisticForMobileApp`).pipe(
      map((res: any) => {
        return res.result;
      }),
    );
  }
}
